import { UNIT_DETAILS_GRID_CONFIG } from './details'
import { UNIT_EVENTS_GRID_CONFIG } from './events'
import { UNIT_SIGNAL_STRENGTH_GRID_CONFIG } from './signal-strength'
import { UNIT_MANAGE_GRID_CONFIG } from './unit-manage'

export const UNIT_GRID_LAYOUT = {
  xxl: [
    // UNIT_NOTES_GRID_CONFIG.layout.xl,
    UNIT_MANAGE_GRID_CONFIG.layout.xxl,
    UNIT_DETAILS_GRID_CONFIG.layout.xxl,
    UNIT_EVENTS_GRID_CONFIG.layout.xxl,
    UNIT_SIGNAL_STRENGTH_GRID_CONFIG.layout.xxl
  ],
  xl: [
    // UNIT_NOTES_GRID_CONFIG.layout.xl,
    UNIT_MANAGE_GRID_CONFIG.layout.xl,
    UNIT_DETAILS_GRID_CONFIG.layout.xl,
    UNIT_EVENTS_GRID_CONFIG.layout.xl,
    UNIT_SIGNAL_STRENGTH_GRID_CONFIG.layout.xl
  ],
  lg: [
    // UNIT_NOTES_GRID_CONFIG.layout.lg,
    UNIT_MANAGE_GRID_CONFIG.layout.lg,
    UNIT_DETAILS_GRID_CONFIG.layout.lg,
    UNIT_EVENTS_GRID_CONFIG.layout.lg,
    UNIT_SIGNAL_STRENGTH_GRID_CONFIG.layout.lg
  ],
  md: [
    // UNIT_NOTES_GRID_CONFIG.layout.md,
    UNIT_MANAGE_GRID_CONFIG.layout.md,
    UNIT_DETAILS_GRID_CONFIG.layout.md,
    UNIT_EVENTS_GRID_CONFIG.layout.md,
    UNIT_SIGNAL_STRENGTH_GRID_CONFIG.layout.md
  ],
  sm: [
    // UNIT_NOTES_GRID_CONFIG.layout.sm,
    UNIT_MANAGE_GRID_CONFIG.layout.sm,
    UNIT_DETAILS_GRID_CONFIG.layout.sm,
    UNIT_EVENTS_GRID_CONFIG.layout.sm,
    UNIT_SIGNAL_STRENGTH_GRID_CONFIG.layout.sm
  ],
  xs: [
    // UNIT_NOTES_GRID_CONFIG.layout.xs,
    UNIT_MANAGE_GRID_CONFIG.layout.xs,
    UNIT_DETAILS_GRID_CONFIG.layout.xs,
    UNIT_EVENTS_GRID_CONFIG.layout.xs,
    UNIT_SIGNAL_STRENGTH_GRID_CONFIG.layout.xs
  ],
  xxs: [
    // UNIT_NOTES_GRID_CONFIG.layout.xxs,
    UNIT_MANAGE_GRID_CONFIG.layout.xxs,
    UNIT_DETAILS_GRID_CONFIG.layout.xxs,
    UNIT_EVENTS_GRID_CONFIG.layout.xxs,
    UNIT_SIGNAL_STRENGTH_GRID_CONFIG.layout.xxs
  ]
}
